import { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    CircularProgress,
    Divider,
    Stack,
    Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { COLORS } from '../../utils/Application_Constants';

const ReviewReasonsAccordion = ({ reviewReasons, exceptionNotes, loading }) => {
    const hasIssues = reviewReasons?.length > 0 || exceptionNotes?.length > 0;
    const Icon = hasIssues ? InfoOutlinedIcon : CheckCircleIcon;

    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        if (loading) return;
        if (hasIssues) setExpanded(true);
    }, [loading, hasIssues]);

    return (
        <Accordion
            variant="lt-admin"
            sx={{
                '& .MuiButtonBase-root.Mui-disabled': {
                    opacity: '1 !important', // override disabled loading opacity
                },
            }}
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
        >
            <AccordionSummary
                expandIcon={hasIssues ? <ExpandMoreIcon fontSize="small" /> : null}
                aria-controls="review-reasons-content"
                id="review-reasons-header"
                disabled={!hasIssues}
            >
                <Stack direction="row" gap="12px" alignItems="center">
                    {loading ? (
                        <CircularProgress color="primary" />
                    ) : (
                        <>
                            <Icon viewBox="2 2 20 20" sx={{ width: 16, height: 16 }} />
                            <Typography component="span">
                                {hasIssues ? 'Reasons for review' : 'No issues found'}
                            </Typography>
                        </>
                    )}
                </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ color: COLORS.LT_MIDNIGHT, fontSize: 12 }}>
                <Stack gap={2} divider={<Divider sx={{ borderBottom: 'none' }} />}>
                    <ul style={{ paddingLeft: 20, margin: 0, lineHeight: '25px' }}>
                        {reviewReasons?.map((reason, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <li key={index}>{reason}</li>
                        ))}
                    </ul>
                    {exceptionNotes?.map((note, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index}>
                            <Typography sx={{ fontSize: 'inherit', fontWeight: 600 }}>
                                {note.label}:
                            </Typography>
                            <Typography sx={{ fontSize: 'inherit', fontWeight: 400 }}>
                                {note.text}
                            </Typography>
                        </div>
                    ))}
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
};

export default ReviewReasonsAccordion;
